module.exports = __webpack_public_path__ + "img/r2b.fe3bdbe6.png";